import { NotesService } from '../../../BaseFramework/core/http/notes.service';
import { HttpRequest, HttpClient, HttpEventType, HttpEvent, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { environment } from 'environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ClientService,
  AppConfig,
  ComponentOutputDO,
  AppMetadataHandler,
  UserInfoService
} from 'app'
import { AbstractControl, UntypedFormBuilder, FormControl, UntypedFormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { error } from 'console';

interface correspondenceDO {
  id: any,
  entityGuid: any;
  templateCd: any;
  overRideFl: any;
  receipent: any;
  cc: any;
  bcc: any;
  subject: any;
  templateContents: any;
  userReqFl: any;
  statusCd: any;
  templateDesc:any;
  channelCd: any;
  createdDt: any;
  configTo : any;
}

interface CorrespondenceMsgDO {
  id: any,
  entityGuid: any;
  corresGuid: any;
  message: any;
  templateContents: any;
  bodyContents: any;
  body: any;
  fileNameParams:any;
  recipient:any;

}

interface lookupObject {
  key: any, value: any
}

@Component({
  selector: 'app-correspondence-manager',
  templateUrl: './correspondence-manager.component.html',
  styleUrls: ['./correspondence-manager.component.scss']
})
export class CorrespondenceManagerComponent implements OnInit {
  _currentComponentName = 'CorrespondeceManagerComponent'

  constructor(
    private message: NzMessageService,
    private apiRequest: ApiRequestService,
    private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private fb: UntypedFormBuilder,
    private http: HttpClient,
    private commonUtilty: CommonUtilty,
    private appConfig: AppConfig,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private lookupDataService: LookupDataService,
    private clientService: ClientService,
    private noteService: NotesService,
    private notification: NzNotificationService,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler,
    private userInfoService: UserInfoService
  ) { }

  //Declaraions which might need developer input
  correspondenceManagerForm: UntypedFormGroup
  CORRESPONDENCEMANAGERFORM = "correspondenceManagerForm"
  selectorOfThisComponent = 'app-correspondece-manager'
  lookupsToBind = ['cor_Templates']
  parentEvent$

  @Output() componentOutput = new EventEmitter<any>();
  @Input() transactionState: any;


  corList: any;
  emailList: any;
  mobList: any;
  public _IO = null;
  @Input()
  set IO(value: any) {
    this._IO = value;
    console.log("value", value)
    this.getDoDetails();
  };
  _state:any;
  @Input() set state(value: any) {
    this._state = value
  }
  get state() {
    return this._state
  }
  
  viewType:string;
  userLoggedIn:any=null;
  loggedInUser:any=null;

  DO: any;
  contactNum:any;
  emailId:any;
  private getDoDetails() {
    this.DO = this.getDO(this._IO);
    if (this._IO) {
      
      this.corList = this._IO.correspondences;
      this.mobList = this.getClientContact();
      this.emailList = this.getClientEmail();
      this.checkPrefferedEmailAndContact()
    }
    if (this.DO != null) {
      // this.fetchCorList(this.DO);
    }
    

  }

  emptycorrespondenceDO: correspondenceDO = {
    id: null,
    entityGuid: null,
    templateCd: null,
    overRideFl: null,
    receipent: null,
    cc: null,
    bcc: null,
    subject: null,
    templateContents: null,
    userReqFl: null,
    statusCd: null,
    channelCd: null,
    templateDesc:null,
    createdDt:null,
    configTo : null
  }

  emptyCorrespondenceMsgDO: CorrespondenceMsgDO = {
    id: null,
    entityGuid: null,
    corresGuid: null,
    message: null,
    templateContents: null,
    bodyContents: null,
    body: null,
    fileNameParams:[],
    recipient:null

  }

  // Editor  properties

//Hide toolbar from every correspondence
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: false,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      {class: 'arial', name: 'Arial'},
      {class: 'times-new-roman', name: 'Times New Roman'},
      {class: 'calibri', name: 'Calibri'},
      {class: 'comic-sans-ms', name: 'Comic Sans MS'}
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'v1/image',
    //uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top',
    // toolbarHiddenButtons: [
    //   ['bold', 'italic'],
    //   ['fontSize'],
    //   ['image']
    // ]
  };





  get IO() {
    return this._IO;
  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try { return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component } catch { };
  }
  getParentComponentName(): string {
    try { return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name } catch { };
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      this.EmitComponentOutput(null);
    })
  }

  validateOutput(o) {
    this.commonUtilty.markAllFieldDirty(o);
    return true
  }

  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }
    if (this.IO != null)
      this.initializeNotesForm(this.IO)
    this.subscribeToParentEvent()
    this.correspondenceDO.channelCd = "Email"

    // this.getVocabullary()
    this.checkPrefferedEmailAndContact()
    // this.fetchCorList(this.DO);
    // this.removeDuplicateCorrespondence();

    this.route.data.subscribe(data => {
      this.viewType = data.breadcrumb.toUpperCase();
    });
    this.checkviewTypeAndUser();
  }

  initializeNotesForm(data?) {
    let payload = data || {}
    this.correspondenceManagerForm = this.fb.group({

    });
    this.templateType = "select template";
  }


  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format("DD MMM YYYY HH:mm:ss");
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }



  correspondenceDO: correspondenceDO = this.commonUtilty.deepCopy(this.emptycorrespondenceDO);
  correspondenceMsgDO: CorrespondenceMsgDO = this.commonUtilty.deepCopy(this.emptyCorrespondenceMsgDO);
  correspondence: any[] = [];
  errorMessage: any = null;
  saveCorrespondence() {

    if (this.corsEditMode) return false;

    let validationFlag = this.validateForm()

    if (validationFlag) {
      this.correspondenceDO.entityGuid = this.DO.guid;
      this.correspondenceDO.userReqFl = true;
      this.correspondence.push(this.correspondenceDO);
      // if(this.correspondenceDO && this.correspondenceDO.overRideFl == null){
      // this._IO.correspondences.push(this.correspondenceDO);
      // }
      if(this.correspondenceDO && this.correspondenceDO.statusCd == null){
        this.correspondenceDO.statusCd = "PENDING";
        this.correspondenceDO.createdDt = new Date();
      }
      let payload = { notes: this.correspondence }
      if(this.correspondenceDO.receipent == null) {
        this.message.warning(`Please enter the recipient.`, { nzDuration: 4000 })
      }
      if(this.correspondenceDO.templateCd == null){
        this.message.warning(`Please select the template.`, { nzDuration: 4000})
      }
      else
      if(this.correspondenceDO.receipent != null){
   //   let serviceId = this.message.loading('Saving').messageId;
      this.noteService.saveCorrespondence(this.correspondenceDO).subscribe(resp => {
        // this._IO.correspondences.forEach(item =>{
        //   if(item.id == null){
        //     item.id = resp.id
        //   }
        // })
        if(this._IO.correspondences && resp.overRideFl == null){
          this._IO.correspondences.push(resp)
          this.fetchCorList(this.DO);
        }
        this.correspondenceMsgDO.entityGuid = this.DO.guid;
        this.correspondenceMsgDO.corresGuid = resp['guid']
        this.correspondenceMsgDO.fileNameParams=this.getFileNameParams();
        //this.correspondenceMsgDO.message = this.correspondenceDO.templateContents;
        //this.correspondenceMsgDO.templateContents = this.correspondenceDO.templateContents;
        if(this.isEdited)
          this.correspondenceMsgDO.message = this.editedMessage
        if(this.editedBody)
        this.correspondenceMsgDO.body = this.editedBody
        
         this.noteService.saveCorrespondenceMSG(this.correspondenceMsgDO).subscribe(res => {
        //  this.message.remove(serviceId);
          this.refreshComponent()
          this.changingStatus(resp)
         // this.correspondenceDO.channelCd = "Email";
          //this.correspondenceDO = this.commonUtilty.deepCopy(this.emptycorrespondenceDO);
          this.correspondenceDO = this.commonUtilty.deepCopy(resp);
          this.modalCorrespNew = false
        },
          (error) => {
            throw " Something went while saving correspondence message";
          }


        ); 


      },
        (error) => {
          throw " Something went wrong";
        }
      );
      }
    }
    else {
      this.notification.warning('An error has occurred.', this.errorMessage, { nzDuration: 2000 });
    }
  }

  correspondenceMsgCopy:any
  correspondenceBodyCopy:any
  editedMessage:any
  editedBody:any
  isBodyEdited=false
  isEdited=false
  msgChange(event) {
    console.log(event)
    if (this.correspondenceMsgCopy) {
      let dataArray = this.correspondenceMsgCopy.split("</head>")
      let bodyArray = event.split("</style>")
      if (dataArray && dataArray.length > 1 && bodyArray && bodyArray.length > 1) {
        //this.editedMessage = dataArray[0] + "</head>" + event + "</body>"
          this.editedMessage = dataArray[0] + "</head> <body>" + bodyArray[1] + "</body>"
          this.editedMessage=this.editedMessage.replaceAll("<tbody>","")
          this.editedMessage=this.editedMessage.replaceAll("</tbody>","")
        this.isEdited = true
      }
    }
  }

  onBodyChange(event) {
    if (this.correspondenceBodyCopy) {
      let dataArray = this.correspondenceBodyCopy.split("</head>")
      let bodyArray = event.split("</style>")
      if (dataArray && dataArray.length > 1 &&  bodyArray && bodyArray.length > 1) {
        //this.editedBody = dataArray[0] + "</head>" + event + "</body>"
        this.editedBody = dataArray[0] + "</head> <body> " + bodyArray[1] + "</body>"
        this.editedBody=this.editedBody.replaceAll("<tbody>","")
        this.editedBody=this.editedBody.replaceAll("</tbody>","")
        this.isBodyEdited = true
      }
    }
  }

  _refreshComponent = true
  refreshComponent(){
    this._refreshComponent = false
    setTimeout(()=>{this._refreshComponent = true},10)
  }

  verifyCorres() {

    if (this.corsEditMode) return false;
    let validationFlag = this.validateForm()
    if (validationFlag) {
      this.correspondenceDO.entityGuid = this.DO.guid;
      this.correspondenceDO.userReqFl = false;
      this.correspondence.push(this.correspondenceDO);
      let payload = { notes: this.correspondence }
      if(this.correspondenceDO.receipent == null && this.correspondenceDO.channelCd != "LETTER") {
        this.message.warning(`Please enter the recipient.`, { nzDuration: 4000 })
      }
      if(this.correspondenceDO.templateCd == null){
        this.message.warning(`Please select the template.`, { nzDuration: 4000})
      }
      else
      if(this.correspondenceDO.receipent != null || this.correspondenceDO.channelCd == "LETTER"){
      let serviceId = this.message.loading('Saving').messageId;
      //this.noteService.saveCorrespondence(this.correspondenceDO).subscribe(resp => {
        this.noteService.verifyCorrespondence(this.correspondenceDO).subscribe(resp => {
        this.message.success("Correspondence verified successfully");
        this.changingStatusVerify(resp)
        if(resp && resp.statusCd =="VERIFIED"){
          this.editorConfig.editable = false;
        }
        this.refreshComponent()
        this.correspondenceDO = resp;
      },
        (error) => {
          throw " Something went wrong";
        }
       );
      }
    }
    else {
      this.notification.warning('An error has occurred.', this.errorMessage, { nzDuration: 2000 });
    }

  }

  unVerifyCorrespondenceDo(){

    this.noteService.unVerifyCorrespondence(this.correspondenceDO).subscribe(resp => {
      this.message.success("Correspondence Unverified successfully");
      this.changingStatusVerify(resp)
      this.refreshComponent()
      this.correspondenceDO = resp;
    },
    (error) => {
      throw " Something went wrong";
    }
   );
  }

  changingStatus(resp){
  this.corList.forEach(val=>{
    if(val.guid === resp.corresGuid)
  val.statusCd = this.commonUtilty.deepCopy(resp.statusCd)
  })
  }

  changingStatusVerify(resp){
    this.corList.forEach(val=>{
      if(val.guid === resp.guid)
    val.statusCd = this.commonUtilty.deepCopy(resp.statusCd)
    })
  }


  validateForm() {
    let flag = true;
    this.errorMessage = null
    if (this.correspondenceDO.channelCd === "Email") {
      if (this.correspondenceDO.receipent == null) {
        this.errorMessage = "Please enter receipent"
        flag = false;
      }
      if (this.correspondenceMsgDO.message == null) {
        flag = false;
        this.errorMessage = "Please enter contents"
      }
      if (this.correspondenceDO.subject == null) {
        flag = false;
        this.errorMessage = "Please enter subject"
      }
    }
    else
      if (this.correspondenceDO.channelCd === "Sms") {

        if (this.correspondenceDO.receipent == null) {
          this.errorMessage = "Please enter receipent"
          flag = false;
        }
        if (this.correspondenceMsgDO.message == null) {
          flag = false;
          this.errorMessage = "Please enter contents"
        }
      }
      else {

        if (this.correspondenceMsgDO.message == null && this.correspondenceDO.channelCd != "INTERNALEMAIL") {
          flag = false;
          this.errorMessage = "Please enter contents"
        }

      }
    return flag;
  }

  entityGuid=null;
  intimationNum=null;
  claimNum=null;
  policyNum=null;
  getFileNameParams(){
    let fileParam=[]
    // this.setFileNameParamsForCorrespondence()
    fileParam.push(this.entityGuid)
    fileParam.push(this.intimationNum)
    fileParam.push(this.claimNum)
    fileParam.push(this.policyNum)
    return fileParam
  }
  setFileNameParamsForCorrespondence() {
    if (this.IO != null) {
      if (this.IO['proposalDO'] || this.IO['caseDO']) {
        if (this.IO['intimationDO']) {
          this.intimationNum = this.IO['intimationDO']['clmIntimationNum']
          this.entityGuid = this.IO['intimationDO']['guid']
          let policies = this.IO['intimationDO']['policies']
          let policyDO
          if (this.commonUtilty.isArrayIterable(policies)) {
            policyDO = policies.find(item => true)
            this.policyNum = policyDO.policyNum
          }
        }
        else if (this.IO['preauthorizationDO']) {
          let policies = this.IO['preauthorizationDO']['policies']
          this.intimationNum = this.IO['preauthorizationDO']['clmIntimationNum']
          this.entityGuid = this.IO['preauthorizationDO']['guid']
          this.claimNum = this.IO['preauthorizationDO']['preAuthNum']
          let policyDO
          if (this.commonUtilty.isArrayIterable(policies)) {
            policyDO = policies.find(item => true)
            this.policyNum = policyDO.policyNum
          }
        } 
        else if (this.IO['claimDO'] || this.IO['investigationDO']) {
          let policies = this.IO['claimDO']['policies']
          this.intimationNum = this.IO['claimDO']['clmIntimationNum']
          this.entityGuid = this.IO['claimDO']['guid']
          this.claimNum = this.IO['claimDO']['claimNum']
          let policyDO
          if (this.commonUtilty.isArrayIterable(policies)) {
            policyDO = policies.find(item => true)
            this.policyNum = policyDO.policyNum
          }
        } 
         else if (this.IO['proposalDO']) {
          let policies = this.IO['proposalDO']['policies']
          this.intimationNum = this.IO['proposalDO']['clmIntimationNum']
          this.entityGuid = this.IO['proposalDO']['guid']
          this.claimNum = this.IO['proposalDO']['preAuthNum']
          let policyDO
          if (this.commonUtilty.isArrayIterable(policies)) {
            policyDO = policies.find(item => true)
            this.policyNum = policyDO.policyNum
          }
        } 
         else if (this.IO['caseDO']) {
          let policies = this.IO['caseDO']['policies']
          this.intimationNum = this.IO['caseDO']['clmIntimationNum']
          this.entityGuid = this.IO['caseDO']['guid']
          this.claimNum = this.IO['caseDO']['preAuthNum']
          let policyDO
          if (this.commonUtilty.isArrayIterable(policies)) {
            policyDO = policies.find(item => true)
            this.policyNum = policyDO.policyNum
          }
        } 
      }
    }
  }
      
    
  

  modeltemplateChange(event) {
    this.noteService.getTemplateByCode(event)
      .subscribe(resp => {
        // this.correspondenceDO.templateContents = resp.contents;
        this.correspondenceDO.templateCd=resp.templateCd;
        this.correspondenceDO.templateDesc=resp.description;
        this.correspondenceMsgDO.message = resp.contents;
        this.correspondenceMsgDO.body=resp.body;
      },
        (error) => {
          throw " Something went wrong";
        }
      );
  }

  getClienNameByGuid(clientRefGuid) {
    let filterOutput = null;
    let output = {}
    let ownerRefGuid;
    let name = null;

    let clientDO = this._IO['clientDOs'];
    if (clientDO) {
      filterOutput = clientDO.find(item => {
        if (item)
          return item['guid'] === clientRefGuid;
      }) || []
    }
    if (filterOutput != null) {
      if (filterOutput['clientTypeCd'] === 'PERSON') {
        let firstName = this.commonUtilty.getFirstNameFromClient(filterOutput)
        let lastName = this.commonUtilty.getLastNameFromClient(filterOutput);
        if (firstName == null)
          firstName = '-'
        if (lastName == null)
          lastName = '-'
        output['name'] = (firstName || "") + " " + (lastName || ""),
          output['isAvailable'] = true;
      } else {
        let firstName = this.commonUtilty.getOrgCompanyNameFromClient(filterOutput) || null
        if (firstName == null)
          firstName = '-'
        output['name'] = (firstName || '')
        output['isAvailable'] = true;
      }
    }
    else {
      output['name'] = '-';
      output['isAvailable'] = false;
    }
    return output;
  }

  //TODO Ramesh Copy this to Product
  resetAllFields() {
    this.corsEditMode = false;
    this.correspondenceDO = this.commonUtilty.deepCopy(this.emptycorrespondenceDO);
    // this.correspondenceDO.channelCd = "EMAIL"
    this.correspondenceMsgDO = this.commonUtilty.deepCopy(this.emptyCorrespondenceMsgDO);
    this.modalBtnText = "Save";
    if(this.correspondenceDO || this.correspondenceMsgDO){
      this.editorConfig.editable = true;
    }
  }


  corsEditMode: boolean = false;
  // TODO Ramesh: Copy this to Product
  modalBtnText: string = "Save";
  showFooter = null;
  showSend= null;
  filteredList = [];
  fetchMessageByGuid(corrsDO) {

    this.checkviewTypeAndUser();

    if(corrsDO && corrsDO.channelCd == "SMS"){
      this.editorConfig.editable = false;
    }

    if(corrsDO && corrsDO.channelCd == "WHATSAPP" && (corrsDO.statusCd == "DISPATCHED" || corrsDO.statusCd == "VERIFIED")){
      this.editorConfig.editable = false;
    }
    
    if(corrsDO && corrsDO.channelCd == "LETTER" && (corrsDO.statusCd == "VERIFIED" || corrsDO.statusCd == "DISPATCHED")){
      this.editorConfig.editable = false;
    }

    if(corrsDO && corrsDO.channelCd == "LETTER" && corrsDO.statusCd == "PENDING"){
      this.editorConfig.editable = true;
    }

    if (corrsDO.channelCd == "EMAIL")
      this.editorConfig.editable = true;
    
    if(corrsDO){
          this.templateType= null;
        }
    

    if(corrsDO.statusCd == 'VERIFIED')
      this.showSend=true;
      else
      this.showSend=null;
    

    if (corrsDO.statusCd != "PENDING") {
      this.corsEditMode = true;
      this.modalBtnText = "Close";
      this.showFooter = null;
    } else {
      this.corsEditMode = false;
      this.modalBtnText = "Save";
      this.showFooter = true
    }
    this.noteService.getCorrMsgByGuid(corrsDO.guid).subscribe(resp => {
      this.correspondenceDO = corrsDO;
      if (resp)
      //resp.templateContents = this.sanitizer.bypassSecurityTrustHtml(resp.templateContents);
      //resp.message = this.sanitizer.bypassSecurityTrustHtml(resp.message);
      this.correspondenceMsgDO = resp;
      this.correspondenceMsgCopy = resp.message
      this.correspondenceBodyCopy=resp.body
      this.modalCorrespNew = true;
      if(corrsDO.channelCd =='LETTER')
        this.showPdfPreview('preview')

      this.modelChanged(this.correspondenceDO.channelCd);

    }
    );
  }

  cancelCorres() {
    this.modalCorrespNew = false;
  }
  
  mobArray:any;
  arrayList:any;
  whatsappMessage:any;
  modelChanged(event) {

    if(event === 'SMS' || event === 'WHATSAPP'){
      this.mobArray = this.mobList
      this.mobArray = this.mobArray.filter((element , i)=> i === this.mobArray.indexOf(element)
      );
      console.log(this.mobArray)
    }
    
    if(event === "LETTER" || event === "EMAIL" || event === 'INTERNALEMAIL'){
      this.arrayList = this.emailList
      this.arrayList = this.arrayList.filter((element , i)=> i === this.arrayList.indexOf(element)
      );
      console.log(this.arrayList)
    }

    if (event === 'SMS') {
      // this.correspondenceDO.templateContents = null
      // this.correspondenceDO.receipent = null
      this.correspondenceDO.bcc = null
      this.correspondenceDO.cc = null
    }
    if (event === 'PDF') {
      this.correspondenceDO.templateContents = null
      // this.correspondenceDO.receipent = null
      this.correspondenceDO.bcc = null
      this.correspondenceDO.cc = null
    }
    // if (event === 'EMAIL' || event === 'LETTER' || event === 'INTERNALEMAIL') {
    //   // this.correspondenceDO.templateContents = null
    //   // this.correspondenceDO.receipent = null
    // }

    if(event === 'WHATSAPP'){
      this.whatsappMessage = this.correspondenceMsgDO.message
      this.whatsappMessage = this.whatsappMessage.replace(/(\r\n|\n|\r|\\n)/gm, '');
      console.log(this.correspondenceMsgDO.message)
    }
  }

  getDO(IO) {
    let output = null
    if (IO != null) {
      switch (this.transactionState) {
        case "corres": {
          if (IO['proposalDO'] || IO['caseDO']) {
            if (IO['proposalDO'])
              output = IO['proposalDO']

            if (IO['caseDO'])
              output = IO['caseDO']

            break;
          }
        }
        default: {
          console.log("Invalid choice");
          break;
        }
      }
    }

    return output
  }



  getClientEmail() {
    let tempArray = [];

    if (this._IO) {
      if (this._IO['clientDOs'] && this._IO['clientDOs'].length > 0) {
        this._IO['clientDOs'].forEach(element => {
          if (element && element.clientEmails) {
            element.clientEmails.forEach(element1 => {
              tempArray.push(element1.emailId);
            });
          }
        });
      }

    }

    return tempArray;
  }




  getClientContact() {
    let tempArray = [];
    if (this._IO) {
      if (this._IO['clientDOs'] && this._IO['clientDOs'].length > 0) {
        this._IO['clientDOs'].forEach(element => {
          if (element && element.clientContactDetails) {
            element.clientContactDetails.forEach(element1 => {
              tempArray.push(element1.contactNum);
            });
          }
        });
      }
    }
    return tempArray;


  }




  // static part
  // static contents later delete from here
  // replacementArray: any = [
  //   { key: "Claimant Name", value: '%claimant_name%' },
  //   { key: "Claim No", value: '%claim_number%' },
  //   { key: "Life-Assured Name", value: '%lifeassured_name%' },
  //   { key: "Missing Documents List", value: '%missing_documents%' },
  // ];



  replacementArray = [];
  getVocabullary() {
    this.apiRequest.getCallWithAPIMapper("masterVocabularyFetchAll").subscribe(data => {
      this.replacementArray = data
      if (data && data.length > 0) {
        data.forEach(element => {
          let obje: lookupObject = { key: null, value: null }
          obje.key = element.vocabulary.description
          obje.value = element.vocabulary.vocabularyCd
          if (!!obje.value)
            this.replacementArray.push(obje);
        });
      }
    });
  }




  handleFileUpload(data) {
  }

  replacementSelected: any = null;
  replacementSelectedKaValue: any = null;
  replacementSelect(i) {
    this.replacementSelectedKaValue = "{_" + i + "_}";
  }

  modalCorrespNew: boolean = false;
  openCorrModal() {
    this.modalCorrespNew = true;
    this.modalBtnText = "Save";
    this.showFooter = true
  }

  //TODO Ramesh: Copy this to Product
  refreshCorrespondence() {
    console.log("Working on it");
  }

  modalPreview: boolean = false;
  previewDataStream:any = null;
  previewDataStreamUnsanitized:string = '';

  headers:HttpHeaders = new HttpHeaders({
    'Authorization': this.apiRequestService.token,
    'applicationId': environment.applicationId,
    //'hash': '7h1nk[)j',
  });

  fileFetchEndpoint:string;
  fileUploadEndpoint:string;
  fileFetchEndpointRAW:string;
  


  downloadInProgress = false;
  showPreview(data) {
    let messageId=this.message.info("Loading").messageId
    let downloadDocumentURL = this.apiRequestService.mapperUtil('post','documentDownload/')
    this.fileFetchEndpointRAW = this.apiRequestService.mapperUtil('post','documentDownload/')
    this.fileFetchEndpoint = this.appConfig.baseApiPath + this.fileFetchEndpointRAW;
    this.fileUploadEndpoint = this.appConfig.baseApiPath + downloadDocumentURL;
    let IO={
      "guid" : this.correspondenceDO['guid']
    }
      this.http.post<Blob>(this.fileFetchEndpoint, IO, {
        headers: this.headers,
        responseType: 'blob' as 'json'
      }).subscribe(res => {
      let base64data;
      if (data != 'Download') {
        let reader = new FileReader();
        reader.readAsDataURL(res);
        let me = this;
        // this.modalPreview = true;
        this.previInProgress = false;
        this.modalPDFpreview = true;
        reader.onloadend = function () {
          base64data = reader.result;
          base64data = base64data.split(',')[1];
          /* Decide Charset/Encoding */
          let charsetEncoding = 'data:application/pdf;base64';
          me.previewDataStream = me.base64ToArrayBuffer(base64data); //charsetEncoding + "," + base64data;

        }
      } else {
        this.downloadInProgress = true;
        this.downloadFile(res, "Report.pdf");
        this.downloadInProgress = false;
        this.previInProgress = false;
      }


    });


  }

  /* Emulate a download-file click */
  downloadFile(blob: any, filename: string): boolean {
    if (!filename) filename = 'file.jpg';
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.href = url;
    a.download = filename;
    a.click();
    return true;//url;
  }


  guessFileExtension(url) {
    let filename = this.guessFileName(url);
    return String(filename.substring(filename.indexOf(".")+1)).toLowerCase();
  }
  guessFileName(url) {
    if(!url) return '';
    return url.substring(url.lastIndexOf('/')+1);
  }

  guessFileType(url): string {
    let extension = url;
    if(url && url.length>4) extension = this.guessFileExtension(url);
    /* File Type */
    if(['jpg','png','jpeg','jfif','gif','tiff','tif','bmp','webp'].includes(extension)) return "Image";
    else if(['pdf','doc','docx'].includes(extension)) return "Document";
    else if(['mp4','mov','avi','mpeg','webm'].includes(extension)) return "Video";
    else if(['mp3','wav','ogg'].includes(extension)) return "Audio";
    else if(['xls','xlsx','xlt','xltx','xlsm','xlsb','xla','xlam','xltm'].includes(extension)) return "Sheet";
    else if(['zip','gz','rar','rar5'].includes(extension)) return "Archive";
    else if(['eml','msg'].includes(extension)) return "Email";
    return "File"; // un-supported
  }

  base64ToArrayBuffer(base64) {
    var binary_string =  window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array( len );
    for (var i = 0; i < len; i++)        {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  templateType: any
  // templateArray = [
  //   { key: "intimation_death_sms_claimant", value: "intimation_death_sms_claimant" },
  //   { key: "intimation_death_sms_agent", value: "intimation_death_sms_agent" },
  //   { key: "intimation_death_sms_agentHierarchy", value: "intimation_death_sms_agentHierarchy" },
  //   { key: "intimation_ci_sms_claimant", value: "intimation_ci_sms_claimant" },
  //   { key: "intimation_ci_sms_agent", value: "intimation_ci_sms_agent" },
  //   { key: "intimation_ci_sms_agentHierarchy", value: "intimation_ci_sms_agentHierarchy" },
  //   { key: "reg_death_sms_claimant", value: "reg_death_sms_claimant" },
  //   { key: "reg_ci_sms_claimant", value: "reg_ci_sms_claimant" },
  //   { key: "approval_sms_claimant", value: "approval_sms_claimant" },
  //   { key: "approval_sms_agentHierarchy", value: "approval_sms_agentHierarchy" },
  //   { key: "payout_sms_claimant", value: "payout_sms_claimant" }
  // ]



  modalPDFpreview=false;
  previInProgress=false;
  showPdfPreview(type)
  {
    this.showPreview(type);
    this.previInProgress=true;
    //this.modalPDFpreview=true;
  }

//Send correspondence functionality
isConSendLoading=false;
sendCor=false;
  sendCorrespondence(){

    

    let validationFlag = this.validateForm()

    if (validationFlag) {
      this.correspondenceDO.entityGuid = this.DO.guid;
      this.correspondenceDO.userReqFl = true;
      let serviceId = this.message.loading('Saving').messageId;
      this.correspondenceMsgDO.entityGuid = this.DO.guid;
      this.correspondenceMsgDO.corresGuid
      
      this.noteService.sendCorrespondenceMSG(this.correspondenceMsgDO).subscribe(res => {
          this.fetchCorList(this.DO);
          this.message.remove(serviceId);
          this.refreshComponent()
          this.changingStatus(res)
          //this.correspondenceDO.channelCd = "Email";
          //this.correspondenceDO = this.commonUtilty.deepCopy(this.emptycorrespondenceDO);
          this.correspondenceDO = this.commonUtilty.deepCopy(res);
          this.modalCorrespNew = false
          this.sendCor = false;
        },
          (error) => {
            throw " Something went while sending correspondence message";
          }
        );
      }
    else {
      this.notification.warning('An error has occurred.', this.errorMessage, { nzDuration: 2000 });
    }

  }

  checkPrefferedEmailAndContact(){

    if(this._IO && this._IO.correspondences){
      this._IO.correspondences.forEach(cors =>{
        if(cors.channelCd == 'SMS' || cors.channelCd == 'WHATSAPP')
        if (this._IO && this._IO.clientDOs){
          this._IO.clientDOs.forEach(item =>{
            if(cors.clientRefGuid == item.guid){
            if (this.DO && this.DO.claimClientRoles){
              this.DO.claimClientRoles.forEach(ele =>{
                if( ele.roleCd == "PAYEE" && item.preferredMobileNum){
                  cors.receipent = item.preferredMobileNum;
                }
              });
            }
           }
          });
        }
      });
    }

    if(this._IO && this._IO.correspondences){
      this._IO.correspondences.forEach(cors =>{
        if(cors.channelCd == 'LETTER' || cors.channelCd == 'EMAIL')
        if (this._IO && this._IO.clientDOs){
          this._IO.clientDOs.forEach(item =>{
            if(cors.clientRefGuid == item.guid){
            if (this.DO && this.DO.claimClientRoles){
              this.DO.claimClientRoles.forEach(ele =>{
                if( ele.roleCd == "PAYEE" && item.preferredEmail){
                  cors.receipent = item.preferredEmail;
                }
              });
            }
           }
          });
        }
      });
    }
  }

  fetchCorList(DO){

   if(DO){
    
    this.apiRequestService.getCallWithAPIMapper('corGetMessageByEntityGuid/' + DO.guid).subscribe(data =>{
      console.log(data)
      this.sendCor= true
      this.corList = data;
      if(this._IO && this._IO.correspondences && this.sendCor){
        this._IO.correspondences = this.corList
      }

    })
   }
  }

  checkviewTypeAndUser(){
  // disabling this condition, as discussed with Ganesh
  return true;

  this.userLoggedIn = this.userInfoService.getUserInfo();
  this.loggedInUser = this.userLoggedIn.userId;

  if(this.viewType === 'ENQUIRY' && this.DO && this.DO.currentTaskUser == this.loggedInUser){
    return true;
  }
  else if(this.viewType === 'ENQUIRY' && this.DO && this.DO.currentTaskUser != this.loggedInUser){
    return false;
  }
  else return true;
  }

}